import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from './chevron-left';
import ChevronRight from './chevron-right';
import Tick from './tick';

function Icon({
  type,
  className,
}) {
  switch (type) {
    case 'chevron-left':
      return <ChevronLeft className={className} />;
    case 'chevron-right':
      return <ChevronRight className={className} />;
    case 'tick':
      return <Tick className={className} />;
    default:
      throw new Error('Icon "type" property is required');
  }
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Icon;
